// PaymentHistory.js
import {
  faCheckCircle,
  faClose,
  faFilter,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import SecureLS from "secure-ls";
import MessageModal from "./MessageModal";

const ls = new SecureLS({ encodingType: "aes" });
const username = "admin1";
const password = "abc@123@Q";
const authHeader = "Basic " + btoa(`${username}:${password}`);

// Function to get CSRF token
const getCsrfToken = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/session/token`,
      {
        credentials: "include",
        headers: {
          Accept: "text/plain",
        },
      },
    );

    if (response.ok) {
      const token = await response.text();
      ls.set("usercsrf_token", token);
      return token;
    }

    const storedToken = ls.get("usercsrf_token");
    if (storedToken) {
      return storedToken;
    }

    return null;
  } catch (error) {
    console.error("Error getting CSRF token:", error);
    return ls.get("usercsrf_token") || null;
  }
};

const fetcher = async (url) => {
  try {
    const csrfToken = await getCsrfToken();

    const headers = {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    };

    if (csrfToken) {
      headers["X-CSRF-Token"] = csrfToken;
    }

    const response = await fetch(url, {
      credentials: "include",
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

const PaymentHistory = ({ invoiceorderedItems }) => {
  const [modalSuccessMsg, setModalSuccessMsg] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handlePaymentDelete = async (salesId) => {
    try {
      const freshToken = await getCsrfToken();

      // if (!freshToken) {
      //   setErrorMessage("Unable to authenticate. Please refresh the page.");
      //   setModalError(true);
      //   return;
      // }

      if (window.confirm("Are you sure you want to delete this payment?")) {
        const res = await fetch(
          `${process.env.REACT_APP_PAYMENT_API}/${salesId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: authHeader,
              "Content-Type": "application/vnd.api+json",
              "X-CSRF-Token": freshToken,
            },
            credentials: "include",
          },
        );

        if (res.ok) {
          setModalSuccessMsg(true);
          // mutatesales();
        } else {
          setErrorMessage("Failed to delete payment");
          setModalError(true);
        }
      }
    } catch (error) {
      setErrorMessage("Network error");
      setModalError(true);
    }
  };

  // Check if there are payments to display
  if (
    !invoiceorderedItems?.order?.payments ||
    invoiceorderedItems.order.payments.length === 0
  ) {
    return (
      <div style={styles.PaymentHistorywrapper}>
        <div style={styles.paymentHistory}>
          <h4 style={styles.paymentHistoryTitle}>Payment Details</h4>
          <p style={styles.noPayments}>No payment history available</p>
        </div>
      </div>
    );
  }

  const payments = invoiceorderedItems.order.payments;
  console.log("PAYMENTS??????????", payments);

  return (
    <div style={styles.PaymentHistorywrapper}>
      <div style={styles.paymentHistory}>
        <div style={styles.tableContainer}>
          <table style={styles.itemsTable}>
            <thead>
              <tr>
                <th>#</th>
                <th>Reference</th>
                <th>Date</th>
                <th>Method</th>
                <th>Amount</th>
                <th>Notes</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr
                  key={payment.id || index}
                  style={index % 2 === 0 ? styles.evenRow : styles.oddRow}
                >
                  <td>{index + 1}</td>
                  <td>{payment.reference || "N/A"}</td>
                  <td>{payment.date || new Date().toLocaleDateString()}</td>
                  <td>
                    <span style={getMethodStyle(payment.method)}>
                      {formatPaymentMethod(payment.method)}
                    </span>
                  </td>
                  <td>
                    <strong>GH₵{Number(payment.amount).toFixed(2)}</strong>
                  </td>
                  <td>{payment.notes}</td>
                  <td>
                    <span style={styles.statusBadge}>
                      {payment.status || "Completed"}
                    </span>
                  </td>
                  <td>
                    <td style={styles.actionBTN}>
                      <button
                        style={styles.deleteButton}
                        onClick={() => handlePaymentDelete(payment.uuid)}
                        title="Delete payment"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </td>
                  </td>
                </tr>
              ))}
            </tbody>
            {payments.length > 0 && (
              <tfoot>
                <tr>
                  <td colSpan="4" style={styles.footerCell}>
                    <strong>Total Payments:</strong>
                  </td>
                  <td colSpan="2" style={styles.footerCell}>
                    <strong>GH₵{calculateTotal(payments).toFixed(2)}</strong>
                  </td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {modalSuccessMsg && (
        <MessageModal
          leftIcon={faCheckCircle}
          color="green"
          message="sale deleted successfully!"
          onClose={() => setModalSuccessMsg(false)}
          rightIcon={faClose}
        />
      )}
      {modalError && (
        <MessageModal
          leftIcon={faFilter}
          color="red"
          message={errorMessage}
          onClose={() => setModalError(false)}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

// Helper function to calculate total payments
const calculateTotal = (payments) => {
  return payments.reduce(
    (total, payment) => total + Number(payment.amount || 0),
    0,
  );
};

// Helper function to format payment method
const formatPaymentMethod = (method) => {
  if (!method) return "Unknown";

  const methodMap = {
    cash: "Cash",
    mobile_money: "Mobile Money",
    credit_card: "Credit Card",
    debit_card: "Debit Card",
    bank_transfer: "Bank Transfer",
    cheque: "Cheque",
  };

  return (
    methodMap[method.toLowerCase()] ||
    method.charAt(0).toUpperCase() + method.slice(1)
  );
};

// Helper function to get method-specific styling
const getMethodStyle = (method) => {
  const methodStyles = {
    cash: { background: "#28a745", color: "white" },
    mobile_money: { background: "#17a2b8", color: "white" },
    credit_card: { background: "#ffc107", color: "#212529" },
    debit_card: { background: "#fd7e14", color: "white" },
    bank_transfer: { background: "#6f42c1", color: "white" },
    cheque: { background: "#e83e8c", color: "white" },
  };

  const style = methodStyles[method.toLowerCase()] || {
    background: "#6c757d",
    color: "white",
  };

  return {
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600",
    display: "inline-block",
    ...style,
  };
};

const styles = {
  PaymentHistorywrapper: {
    marginTop: "20px",
  },
  paymentHistory: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  paymentHistoryTitle: {
    margin: "0 0 20px 0",
    fontSize: "18px",
    color: "#333",
    fontWeight: "600",
    paddingBottom: "10px",
    borderBottom: "2px solid #f0f0f0",
  },
  tableContainer: {
    overflowX: "auto",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  itemsTable: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
  },
  th: {
    background: "#333",
    padding: "12px",
    textAlign: "left",
    borderBottom: "2px solid #444",
    fontWeight: "600",
    color: "#fff",
    whiteSpace: "nowrap",
    borderRight: "1px solid #444",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #e0e0e0",
    color: "#555",
    verticalAlign: "middle",
    borderRight: "1px solid #f0f0f0",
  },
  evenRow: {
    background: "#fafafa",
  },
  oddRow: {
    background: "white",
  },
  statusBadge: {
    background: "#28a745",
    color: "white",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600",
    display: "inline-block",
  },
  noPayments: {
    textAlign: "center",
    padding: "20px",
    color: "#666",
    fontStyle: "italic",
  },
  footerCell: {
    padding: "12px",
    background: "#f8f9fa",
    borderTop: "2px solid #e0e0e0",
    textAlign: "right",
  },
};

export default PaymentHistory;
